import { render, staticRenderFns } from "./backgroundDetail.vue?vue&type=template&id=a563d7e6&"
import script from "./backgroundDetail.vue?vue&type=script&lang=js&"
export * from "./backgroundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports